import {useEffect, useRef} from "react";

/**
 * Utility hook for storing previous value
 */
export const usePrevious = <T>(value: T): T | undefined => {
    const ref = useRef<T>();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};
